import React, { useCallback } from "react";
import { IBranch } from "../../types";
import Grid from "@material-ui/core/Grid";
import { Theme } from "@material-ui/core";
import FontIcon from "../../../../components/FontIcon";
import makeStyles from "@material-ui/core/styles/makeStyles";
import LabeledContent from "../../../../components/LabeledContent";
import Paper from "@material-ui/core/Paper";
import { Routes } from "../../../../constants/routes";
import { AdapterLink } from "../../../../components/Adopter";
import useSchoolQueries from "../../hooks/useSchoolQueries";
import { useSnackbar } from "notistack";
import Dialog from "../../../../components/Dialog";
import { mutateErrors, urlReplacer } from "../../../../utils";
import IconButton from "../../../../components/IconButton";

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      borderBottom: "1px solid #dfdcd6",
    },
  },
  buttonsContainer: {
    display: "flex",
    textAlign: "center",
    justifyContent: "space-between",
    alignSelf: "center",
  },
  paper: {
    padding: theme.spacing(3),
  },
}));
export default function AdminBranchListItem({
  onDelete,
  branch,
}: {
  index: number;
  onDelete: Function;
  branch: IBranch;
}) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const { fetchDelete } = useSchoolQueries();

  const handleDelete = useCallback(async () => {
    try {
      await fetchDelete(branch.id);
      enqueueSnackbar("Success", { variant: "success" });
    } catch (e) {
      const { message } = mutateErrors(e);
      enqueueSnackbar(message, { variant: "error" });
    }
    if (typeof onDelete == "function") onDelete();
    closeDialog();
  }, [fetchDelete, branch]); // eslint-disable-line react-hooks/exhaustive-deps

  const openDialog = useCallback(() => {
    setDialogOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setDialogOpen(false);
  }, []);

  return (
    <>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Grid
            container
            spacing={2}
            justify={"space-between"}
            alignItems={"flex-start"}
          >
            <Grid item xs={12} sm={10}>
              <Grid container spacing={2} alignItems={"center"}>
                <Grid item xs={12} sm={6} md={3} className={classes.content}>
                  <LabeledContent label={"Branch (State or City)"}>
                    {branch.city}
                  </LabeledContent>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className={classes.content}>
                  <LabeledContent label={"Address"}>
                    {branch.address}
                  </LabeledContent>
                </Grid>
                <Grid item xs={12} sm={6} md={2} className={classes.content}>
                  <LabeledContent label={"Zip"}>{branch.zip}</LabeledContent>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={"auto"}
              className={classes.buttonsContainer}
            >
              <IconButton
                color={"edit"}
                component={AdapterLink}
                to={`/0/${urlReplacer(Routes.SCHOOL_BRANCH, {
                  id: branch.school.id,
                })}/${branch.id}/edit`}
              >
                <FontIcon fontSize={"small"} name={"edit"} />
              </IconButton>
              <IconButton color={"delete"} onClick={openDialog}>
                <FontIcon fontSize={"small"} name={"delete"} />
              </IconButton>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Dialog
        open={dialogOpen}
        title="Are you sure?"
        contentText="You won't be able to revert this!"
        onClose={closeDialog}
        actions={[
          {
            text: "Cancel",
            color: "primary",
            onClick: closeDialog,
          },
          {
            text: "Delete",
            color: "primary",
            onClick: handleDelete,
          },
        ]}
      />
    </>
  );
}
